import Bowser from 'bowser';

/**
 * Whether the current browser is running on a mobile phone, as opposed to a tablet, desktop, or any
 * other platform. Bowser classifies phones as `mobile` and tablets separately as `tablet`, so this
 * is true only for phones — matching the backend's `isMobilePhone` push-subscription field.
 */
export function isMobilePhone(userAgent: string = navigator.userAgent): boolean {
    return Bowser.parse(userAgent).platform.type === 'mobile';
}
